import { instance } from "./axios";

export const updateMeasurement = (payload, id) => {
  try {
    return instance.put(`/visit/measurement/${id}`, payload);
  } catch (error) {
    throw error;
  }
};
